import { IRevisionDate } from "./IRevisionDate";
import { IUser } from "./IUser";

export interface ISite {
  type: SiteType;
  title: string;
  path: string;
  relativePath?: string;
  appId?: string;
  appInstalled?: boolean;
  children?: ISite[];
  checked?: boolean;
  // page details for Content Organizer
  contentResponsible: IUser[];
  modifiedBy: IUser;
  modified: string;
  revisionDate: IRevisionDate;
  contentType?: ContentType;
  linkingUrl?: string;
}

export enum SiteType {
  Modern,
  Hub
}

export enum ContentType {
  Page,
  Document
}